module.exports = __webpack_public_path__ + "static/img/volkswagen-competition.9d87a4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/volkswagen-competition.jpg
// module id = 1n8s
// module chunks = 0